import styled, { css } from 'styled-components';

export const Element = styled.div<{ active: boolean; completed: boolean }>`
  ${({ theme, active, completed, ...props }) => {
    return css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: start;

      width: 5rem;
      height: 5rem;

      @media screen and (min-width: ${theme.breakpoint.sm}) {
        width: 7rem;
        height: 5rem;
      }

      overflow: hidden;

      // First StepCircle item
      &:nth-of-type(1) {
        > div {
          &:before {
            border: 0 !important;
          }
        }
      }
      // Last StepCircle item
      &:last-child {
        > div {
          &:after {
            border: 0 !important;
          }
        }
      }

      ${active === true &&
      css`
        // <StepCircle>
        > div {
          background: ${theme.color.secondary_200};
          &:before {
            border-color: ${theme.color.secondary_200};
          }
        }
      `};

      ${completed === true &&
      css`
        // <StepCircle>
        > div {
          border: 3px solid white;
          background: ${theme.color.secondary_200};
          box-shadow: ${theme.box_shadow.base};

          &:after,
          &:before {
            border-color: ${theme.color.secondary_200};
          }
        }
      `};
    `;
  }};
`;

export const StepCircle = styled.div`
  ${({ theme, ...props }) => {
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 3rem;
      height: 3rem;
      border-radius: ${theme.radius.full};

      background: ${theme.color.neutral_200};
      font-size: ${theme.typography.font_size.text_xs};
      font-weight: ${theme.typography.font_weight.text_bold};

      border: 1px solid white;

      &,
      &:after,
      &:before {
        transition: all 300ms ease;
      }

      // Effect step
      position: relative;

      &:after,
      &:before {
        content: '';
        position: absolute;
        border-width: 2px;
        border-color: ${theme.color.neutral_200};
      }

      &:before {
        width: 100%;
        transform: translateX(calc(50% - 4.5rem));
      }

      &:after {
        width: 100%;
        transform: translateX(calc(-50% + 4.5rem));
      }
    `;
  }};
`;
